import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EkoElement } from "@/utilities/element";
import style from "./empty-state.css?inline";
import "./empty-state-intro";
import "./empty-state-title";

@customElement("eko-empty-state")
class EmptyState extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) background = false;

  render() {
    return html`
      <div class="eko-empty-state__media-content-wrapper" part="media-content-wrapper">
        <slot class="eko-empty-state__media" name="media"></slot>
        <div class="eko-empty-state__content" part="content">
          <slot name="title"></slot>
          <slot name="intro"></slot>
        </div>
      </div>
      <slot></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-empty-state": EmptyState;
  }
}

export default EmptyState;
